import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#dropdown" }),
    /*#__PURE__*/_createTextVNode(" Dropdown ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Toggleable menu for displaying lists of links and actions. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUITriggeringElement = _resolveComponent("EUITriggeringElement")
  const _component_EUIHowToTrigger = _resolveComponent("EUIHowToTrigger")
  const _component_EUIMenuHidingBehavior = _resolveComponent("EUIMenuHidingBehavior")
  const _component_EUICommandEvent = _resolveComponent("EUICommandEvent")
  const _component_EUISizes = _resolveComponent("EUISizes")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUITriggeringElement),
    _createVNode(_component_EUIHowToTrigger),
    _createVNode(_component_EUIMenuHidingBehavior),
    _createVNode(_component_EUICommandEvent),
    _createVNode(_component_EUISizes)
  ], 64))
}